function Home () {
    return (
        <div className="homeContainer">

            <div className="containerImage"></div>
            <div className="home">
                <h1>💃🏽 Welcome To Melomania 💃🏽</h1>
                <h2 className="mt-5"> Where you can add your favorite songs to listen to and share it with others! </h2>
                <h2 className="mt-2"> In order to use this website you must either login or create an account.</h2>
            </div>

        </div>
        
    )
}

export default Home